module.exports = __webpack_public_path__ + "static/img/iconMrNancy.a949d38.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconMrNancy.svg
// module id = FHAx
// module chunks = 1